import { Button, Icon } from '@shopify/polaris';
import { LockIcon } from '@shopify/polaris-icons';
import React from 'react';
import { Card, CardContent, Message } from './styled';

interface UpgradeCardProps {
  message: React.ReactNode;
  backgroundColor?: string;
  icon?: React.ReactNode;
  onButtonClick: () => void;
  buttonLabel: string;
  textColor?: string;
  style?: React.CSSProperties;
}

const UpgradeCard: React.FC<UpgradeCardProps> = ({
  backgroundColor,
  icon,
  onButtonClick,
  buttonLabel,
  textColor,
  message,
  style,
}) => {
  return (
    <Card backgroundColor={backgroundColor} textColor={textColor} style={style}>
      <span>{icon ?? <Icon source={LockIcon} />}</span>
      <CardContent>
        <Message>{message}</Message>
        <span>
          <Button fullWidth={false} onClick={onButtonClick}>
            {buttonLabel}
          </Button>
        </span>
      </CardContent>
    </Card>
  );
};

export default UpgradeCard;
